module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard"
  }, [(_vm.exibeBannerMatricula) ? _c('div', {
    staticClass: "banner-prematric",
    on: {
      "click": _vm.matriculaOnline
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), _c('dashboard-popup'), _vm._v(" "), (false) ? _c('dashboard-video-popup') : _vm._e(), _vm._v(" "), _c('dashboard-matricula-online'), _vm._v(" "), _c('dashboard-pre-matriculado-popup'), _vm._v(" "), _c('dashboard-valida-meus-dados-popup'), _vm._v(" "), _c('dashboard-verifica-contrato-pendente-de-assinatura-popup'), _vm._v(" "), _c('dashboard-link-form-popup'), _vm._v(" "), _c('dashboard-horarios', {
    staticClass: "box-horarios",
    attrs: {
      "data-intro": "Grade de horários do seu curso",
      "data-step": "1"
    }
  }), _vm._v(" "), _c('dashboard-novidades', {
    staticClass: "box-novidades",
    attrs: {
      "data-intro": "Novidades da URCAMP",
      "data-step": "6"
    }
  }), _vm._v(" "), (!_vm.soEnsinoBasico) ? _c('dashboard-notas-frequencias', {
    staticClass: "box-notas-frequencias",
    attrs: {
      "data-intro": "Suas disciplinas com frequência e notas",
      "data-step": "2"
    }
  }) : _vm._e(), _vm._v(" "), _c('dashboard-qualificacao-urcamp', {
    staticClass: "box-qualificacao-urcamp",
    attrs: {
      "data-intro": "Cursos Extras para sua qualificação",
      "data-step": "7"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box-links"
  }, [_c('div', {
    staticClass: "box-links-content",
    attrs: {
      "data-intro": "Links úteis para Ensino Híbrido, Moodle, Sistema de Eventos e muito mais",
      "data-step": "8"
    }
  }, [(_vm.professor) ? _c('dashboard-box-link', {
    attrs: {
      "title": "Webdiário",
      "icon-class": "fas fa-chalkboard-teacher",
      "href": "https://webdiario.urcamp.edu.br",
      "number": "link1"
    }
  }) : _vm._e(), _vm._v(" "), _c('dashboard-box-link', {
    attrs: {
      "title": "Ambientes Virtuais",
      "icon-class": "fas fa-user-graduate",
      "number": "link2",
      "click": _vm.abrirModalAmbientesVirtuais
    }
  }), _vm._v(" "), _c('dashboard-box-link', {
    attrs: {
      "title": "Sou I",
      "icon-class": "fas fa-handshake",
      "href": "https://soui.urcamp.edu.br",
      "number": "link4"
    }
  }), _vm._v(" "), (!_vm.soEnsinoBasico) ? _c('dashboard-box-link', {
    attrs: {
      "title": "Frequências e Notas",
      "icon-class": "fab fa-firstdraft",
      "to": {
        name: 'academico.frequencia-notas'
      },
      "number": "link5"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.soEnsinoBasico) ? _c('dashboard-box-link', {
    attrs: {
      "title": "Boletins e Pareceres",
      "icon-class": "fab fa-firstdraft",
      "to": {
        name: 'academico.boletins-pareceres'
      },
      "number": "link6"
    }
  }) : _vm._e(), _vm._v(" "), _c('dashboard-box-link', {
    attrs: {
      "title": "Resoluções Importantes",
      "icon-class": "fas fa-newspaper",
      "number": "link7",
      "href": "https://urcamp.edu.br/documentos?_page=1&search=&startDate=&endDate=&categories%5B%5D=resolucoes"
    }
  }), _vm._v(" "), _c('dashboard-box-link', {
    attrs: {
      "title": "Agenda de Eventos",
      "icon-class": "fas fa-calendar-alt",
      "number": "link8",
      "href": "https://site.urcamp.edu.br/busca/event"
    }
  }), _vm._v(" "), (!_vm.soEnsinoBasico) ? _c('dashboard-box-link', {
    attrs: {
      "title": "Manual TCC",
      "icon-class": "fas fa-book-reader",
      "number": "link2",
      "href": "https://site.urcamp.edu.br/pesquisa-e-extensao/ediurcamp/livros-e-books-e-websites/manual-do-tcc"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "80%"
    },
    model: {
      value: (_vm.mostrarModalEnsinoHibrido),
      callback: function($$v) {
        _vm.mostrarModalEnsinoHibrido = $$v
      },
      expression: "mostrarModalEnsinoHibrido"
    }
  }, [_c('v-card', {
    staticClass: "infofrafico"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/infografico_ensino_hibrido.jpg"
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.mostrarModalEnsinoHibrido = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": _vm.isMobileSize ? '80%' : '50%'
    },
    model: {
      value: (_vm.mostrarModalAmbientesVirtuais),
      callback: function($$v) {
        _vm.mostrarModalAmbientesVirtuais = $$v
      },
      expression: "mostrarModalAmbientesVirtuais"
    }
  }, [_c('v-card', {
    staticClass: "popup-modal"
  }, [_c('v-container', [_c('h3', {
    staticClass: "pb-3",
    class: {
      'display-0': _vm.isMobileSize, 'display-1': !_vm.isMobileSize
    }
  }, [_vm._v("\n            Ambientes Virtuais\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('div', [_c('h4', {
    staticClass: "pb-0 subheading"
  }, [_c('strong', [_vm._v("PLATAFORMA URCAMP")])]), _vm._v(" "), _c('p', {
    staticClass: "ma-0",
    class: {
      'body-1': _vm.isMobileSize, 'subheading': !_vm.isMobileSize
    }
  }, [_vm._v("\n                É o local destinado ao desenvolvimento do ensino e da aprendizagem a distância nos atuais componentes\n                curriculares de seu curso presencial ou digital. O atual Ambiente Virtual de Aprendizagem da Urcamp\n                está disponível a partir do primeiro semestre do ano de 2025 para o ensino presencial e digital.\n              ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-0 mt-2 text-none",
    attrs: {
      "color": "primary",
      "depressed": "",
      "small": "",
      "block": _vm.isMobileSize
    },
    on: {
      "click": function($event) {
        return _vm.abrirUrlNovaJanela('https://plataforma.urcamp.edu.br')
      }
    }
  }, [_vm._v("\n                Clique aqui para acessar\n              ")])], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "my-3"
  }), _vm._v(" "), _c('div', [_c('h4', {
    staticClass: "pb-0 subheading"
  }, [_c('strong', [_vm._v("MOODLE")])]), _vm._v(" "), _c('p', {
    staticClass: "ma-0",
    class: {
      'body-1': _vm.isMobileSize, 'subheading': !_vm.isMobileSize
    }
  }, [_vm._v("\n                Aqui você acessa os componentes curriculares de seu curso presencial que foram desenvolvidos no\n                Ambiente Virtual de Aprendizagem da Urcamp até o 2º semestre do ano de 2024.\n              ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-0 mt-2 text-none",
    attrs: {
      "color": "primary",
      "depressed": "",
      "small": "",
      "block": _vm.isMobileSize
    },
    on: {
      "click": function($event) {
        return _vm.abrirUrlNovaJanela('https://virtual.urcamp.edu.br')
      }
    }
  }, [_vm._v("\n                Clique aqui para acessar\n              ")])], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "my-3"
  }), _vm._v(" "), _c('div', [_c('h4', {
    staticClass: "pb-0 subheading"
  }, [_c('strong', [_vm._v("PLATAFORMA A - EAD")])]), _vm._v(" "), _c('p', {
    staticClass: "ma-0",
    class: {
      'body-1': _vm.isMobileSize, 'subheading': !_vm.isMobileSize
    }
  }, [_vm._v("\n                Aqui você acessa os componentes curriculares de seu curso EAD que foram desenvolvidos no Ambiente\n                Virtual de Aprendizagem da Urcamp até o 2º semestre do ano de 2024.\n              ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-0 mt-2 text-none",
    attrs: {
      "color": "primary",
      "depressed": "",
      "small": "",
      "block": _vm.isMobileSize
    },
    on: {
      "click": function($event) {
        return _vm.abrirUrlNovaJanela('https://urcamp.grupoa.education/plataforma/auth/signin?returnUrl=%2F')
      }
    }
  }, [_vm._v("\n                Clique aqui para acessar\n              ")])], 1)], 1)]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.mostrarModalAmbientesVirtuais = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner-prematric-icone"
  }, [_c('i', {
    staticClass: "fas fa-graduation-cap fa-4x"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner-prematric-conteudo"
  }, [_c('p', [_vm._v("Pré-matrícula Graduação I")]), _vm._v(" "), _c('h3', {
    staticClass: "headline text-uppercase"
  }, [_vm._v("Clique aqui para fazer sua pré-matrícula.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9405467e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/dashboard/Dashboard.vue
// module id = 570
// module chunks = 2